// maintenance.ts

import { z } from "zod";
import { API_BASE } from "../../state/config";

const MaintenanceStatusResponseSchema = z.object({
    status: z.literal("OK"),
    maintenanceEnd: z.number().int().positive().nullable(),
});

const MAINTENANCE_REQUEST_TIMEOUT_MS = 5_000;

export async function checkMaintenance(): Promise<number | null> {
    const controller = new AbortController();
    const timeout = window.setTimeout(
        () => controller.abort(),
        MAINTENANCE_REQUEST_TIMEOUT_MS,
    );

    try {
        const response = await fetch(`${API_BASE}/api/maintenance`, {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
            cache: "no-store",
            signal: controller.signal,
        });

        if (!response.ok) {
            throw new Error(
                `Maintenance status request failed with HTTP ${response.status}`,
            );
        }

        const raw: unknown = await response.json();
        return MaintenanceStatusResponseSchema.parse(raw).maintenanceEnd;
    } finally {
        window.clearTimeout(timeout);
    }
}
